"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsLoadingFeatureFlags = void 0;
var feature_flag_context_1 = require("./feature-flag-context");
/**
 * returns the client loading state for the purpose of querying different variants either in anonymous or identified context
 * @param {boolean} [isAnonymous=false] - whether the state should be evaluated within an anonymous context or not
 * @returns {boolean} - true if the client is still loading, false otherwise
 */
var useIsLoadingFeatureFlags = function (isAnonymous) {
    if (isAnonymous === void 0) { isAnonymous = false; }
    return (0, feature_flag_context_1.useIsLoading)(isAnonymous);
};
exports.useIsLoadingFeatureFlags = useIsLoadingFeatureFlags;
